package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class LinkedDevicesList(@SerialName("devices") val devices: List<LinkedDevice>)
